export default function cloudflareLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}) {
  // If it's a local image (starts with /)
  if (src.startsWith('/')) {
    return src
  } else if (src.includes('sanity')) {
    return src
  } else if (src.includes('storyblok')) {
    return src
  }

  // Otherwise use Cloudflare
  const params = [`width=${width}`, `quality=${quality || 75}`]
  return `https://select.dev/cdn-cgi/imagedelivery/1zmOcgV1p520E4lLTrYjjg/${src}/${params.join(
    ','
  )}`
}
